import { openModal } from '@core/components/ModalStack';
import { ManualSupportHourModalProps } from './ManualSupportHourModal';

export async function openManualSupportHourModal(props: ManualSupportHourModalProps) {
  const { ManualSupportHourModal } = await import('./ManualSupportHourModal');

  openModal(ManualSupportHourModal, props);
}
